import { inject, Injectable } from '@angular/core';
import { setActiveLanguage } from '@app/+state/dashboard.actions';
import { storeLanguage } from '@app/+state/dashboard.feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardEffects {
    private actions = inject(Actions);

    setLanguage$ = createEffect(
        () =>
            this.actions.pipe(
                ofType(setActiveLanguage),
                tap((action) => storeLanguage(action.language)),
            ),
        { dispatch: false },
    );
}
